module.exports = __webpack_public_path__ + "static/media/snare.973819c2.wav";